export const ProposalStatus = [
    { status: 'Not Started', bg:'#e36c33', id: '0'} ,
    { status: 'In Progress', bg:'cornflowerblue', id: '1'},
    { status: 'Passed', bg:'green', id: '2'},
    { status: 'Failed', bg:'red', id: '3'},
    // { status: 'Drawn', bg:'darkgray', id: '4'}
]

export const CheckBalance = {
    CreateProposalBalance: 100,
    ProposalVote: 1
}

export const genderOptions = [
    {
      value: "F",
      name: "Female",
    },
    {
      value: "M",
      name: "Male",
    },
    {
      value: "T",
      name: "Transgender",
    },
  ];

  export const RolesName : any = {
    admin: 'admin',
    profile: 'profile',
    employee: 'employee',
    agent: 'agent_user',
    driver: 'driver',
    fleet_operator: 'fleet_user',
    vehicle_owner: 'user_vehicle_owner',
    service_provider: 'service_provider_user',
  }